import {
  comparePlanTiers,
  normalizeLegacyPlanTier,
} from '@tabbio/utils/subscription/catalog';
import type {
  PlanTier,
  SubscriptionStateResult,
  SubscriptionWebCheckoutInput,
} from '@tabbio/types';

function getSnapshotTierForPurchase(result: SubscriptionStateResult): PlanTier {
  const snapshot = result.snapshot;
  if (snapshot.planSet === 'employer') {
    return normalizeLegacyPlanTier(
      snapshot.seat?.tier ?? snapshot.workspace?.workspaceTier ?? snapshot.tier,
    );
  }

  return normalizeLegacyPlanTier(snapshot.tier);
}

export function subscriptionStateMeetsPurchaseTier(
  result: SubscriptionStateResult | null,
  input: Pick<SubscriptionWebCheckoutInput, 'planSet' | 'tier' | 'companyId'>,
) {
  if (!result || result.snapshot.planSet !== input.planSet) {
    return false;
  }

  if (
    input.planSet === 'employer' &&
    input.companyId &&
    result.snapshot.workspace?.companyId !== input.companyId
  ) {
    return false;
  }

  return comparePlanTiers(getSnapshotTierForPurchase(result), input.tier) >= 0;
}

/** Authoritative paid individual tier, or null for Free/other plan sets. */
export function getIndividualPaidSubscriptionTier(
  result: SubscriptionStateResult | null,
): Extract<PlanTier, 'plus' | 'pro'> | null {
  if (!result || result.snapshot.planSet !== 'individual') {
    return null;
  }

  const tier = normalizeLegacyPlanTier(result.snapshot.tier);
  return tier === 'plus' || tier === 'pro' ? tier : null;
}
